<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
    style="list-style-type: none;"
  >


    <template #button-content>
      <feather-icon
        :badge="notificationsReadTotal"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </template>





    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          {{$t('notifications')}}
        </h4>
        <b-badge
          pill
          variant="light-primary"
        >
          <!-- 6 New -->
        </b-badge>
      </div>
    </li>






    <!-- Notifications -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <template v-if="notifications && notifications.results">
        <b-link
          v-for="(notification, index) in notifications.results"
          :key="index"
          @click="goToPlace(notification)"
        >
          <b-media>
            <template #aside>
              <!-- <b-avatar
                size="32"
                :src="notification.avatar"
                :text="notification.avatar"
                :variant="notification.type"
              /> -->
            </template>
            <p class="media-heading">
              <span class="font-weight-bolder">
                {{ notification.message }}
              </span>
            </p>
            <!-- <small class="notification-text">{{ notification.subtitle }}</small> -->
          </b-media>
        </b-link>
      </template>

      <!-- System Notification Toggler -->
      <!-- <div class="media d-flex align-items-center">
        <h6 class="font-weight-bolder mr-auto mb-0">
          System Notifications
        </h6>
        <b-form-checkbox
          :checked="true"
          switch
        />
      </div> -->

      <!-- System Notifications -->
      <!-- <b-link
        v-for="notification in systemNotifications"
        :key="notification.subtitle"
      >
        <b-media>
          <template #aside>
            <b-avatar
              size="32"
              :variant="notification.type"
            >
              <feather-icon :icon="notification.icon" />
            </b-avatar>
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ notification.title }}
            </span>
          </p>
          <small class="notification-text">{{ notification.subtitle }}</small>
        </b-media>
      </b-link> -->
    </vue-perfect-scrollbar>






    <!-- Cart Footer -->
    <li class="dropdown-menu-footer">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        block
        @click="$router.push('/notifications')"
      >
      {{$t('read_all_notifications')}}
      </b-button>
    </li>







  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BBadge, BMedia, BLink, BAvatar, BButton, BFormCheckbox } from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters, mapState } from "vuex";
import configs from '../../axios.config'

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data(){
    return {

    }
  },
  async mounted(){
    this.isLoading = true;

    let token
    if(localStorage.getItem('accessWAREHOUSE')){
      token = localStorage.getItem('accessWAREHOUSE')
    }
    await this.$connect(configs.webSocket + '?token=' + token)

    setTimeout( async () => {
      this.$options.sockets.onmessage = (data) => {
        let a  = JSON.parse(data.data)
        if(a && a.action && a.action == 'new_notification'){
          this.FETCH_ALL_NOTIFICATIONS({is_read: false});
          this.$_warningToast(a.message);
        }
      }
    }, 1500)
    await this.FETCH_ALL_NOTIFICATIONS({is_read: false})

    // this.$disconnect()
    this.isLoading = false;
  },
  beforeDestroy() {
    this.$socket.close()
  },
  methods: {
    ...mapActions('app', ['FETCH_ALL_NOTIFICATIONS', 'FETCH_NOTIFICATIONS_SET_NOTIF']),

    async goToPlace(notification){

      if(notification.content_type == 'requirement_for_good'){
        this.$router.push(`/applications/material/view/${notification.object_id}`)
        this.refreshViewMaterial = !this.refreshViewMaterial
      }else if(notification.content_type == 'requirement_for_instrument'){
        this.$router.push(`/applications/instrument/view/${notification.object_id}`)
      }else if(notification.content_type == 'requirement_for_brigade'){
        this.$router.push(`/applications/works/view/${notification.object_id}`)
      }else if(notification.content_type == 'requirement_for_transport'){
        this.$router.push(`/applications/transport/view/${notification.object_id}`)
      }else if(notification.content_type == 'return_of_good'){
        this.$router.push(`/return/view/material/${notification.object_id}`)
      }else if(notification.content_type == 'return_of_instrument'){
        this.$router.push(`/return/view/instrument/${notification.object_id}`)
      }else if(notification.content_type == 'contract'){
        this.$router.push(`/view-agreements/${notification.object_id}`)
      }

      
      await this.$socket.send(JSON.stringify({pk: notification.id, action: "read_notification", request_id: Date.now()}))
      setTimeout(async () => {
        await this.FETCH_ALL_NOTIFICATIONS({is_read: false})
      }, 500)
    },  

  },
  computed:{
    ...mapState('app', ['notifications']),
    refreshViewMaterial: {
      get: function () {
        return this.$store.state.agrements.refreshViewMaterial;
      },
      set: function (newValue) {
        this.$store.commit('application/SET_REFRESH_VIEW_MATERIAL', newValue)
      }
    },
    notificationsReadTotal(){
      let total = 0;
      if(this.notifications && this.notifications.results && this.notifications.results.length > 0){
        this.notifications.results.forEach((elem) => {
          if(elem.is_read == false){
            total++;
          }
        })
      }
      return total
    }
  },
  setup() {
    /* eslint-disable global-require */
    // const notifications = [
    //   {
    //     title: 'Congratulation Sam 🎉',
    //     avatar: 'D',
    //     subtitle: 'Won the monthly best seller badge',
    //     type: 'light-success',
    //   },
    //   {
    //     title: 'New message received',
    //     avatar: 'd',
    //     subtitle: 'You have 10 unread messages',
    //     type: 'light-info',
    //   },
    //   {
    //     title: 'Revised Order 👋',
    //     avatar: 'MD',
    //     subtitle: 'MD Inc. order updated',
    //     type: 'light-danger',
    //   },
    // ]
    /* eslint-disable global-require */

    const systemNotifications = [
      {
        title: 'Server down',
        subtitle: 'USA Server is down due to hight CPU usage',
        type: 'light-danger',
        icon: 'XIcon',
      },
      {
        title: 'Sales report generated',
        subtitle: 'Last month sales report generated',
        type: 'light-success',
        icon: 'CheckIcon',
      },
      {
        title: 'High memory usage',
        subtitle: 'BLR Server using high memory',
        type: 'light-warning',
        icon: 'AlertTriangleIcon',
      },
    ]

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    return {
      // notifications,
      systemNotifications,
      perfectScrollbarSettings,
    }
  },
}
</script>

<style>

</style>
